<template>
  <v-app>
    <v-card
            color="grey lighten-4"
            flat
    >
      <!-- <v-toolbar color="primary darken-1" dark extended -->
      <v-toolbar color="#909399" dark extended
                 >
        <div class="display-1">
          <v-avatar
                  :tile="false"
                  :size="50"
                  color="grey lighten-4"
          >
            <img :src="logo" :size="50" alt="avatar">
          </v-avatar>
          <span class="display-1">{{name}}</span>
        </div>

        <template v-slot:extension >
          <v-menu bottom   origin="center center" transition="scale-transition"   offset-y :nudge-width="100" v-for="(menu,index) in menuShow" :key="index">
            <template v-slot:activator="{ on }" v-if="menu.etat == true" >
              <v-toolbar-title v-on="on" class="mr-auto">
                <span class=" subheading font-weight-thin">{{menu.listeMenu}} </span>
                <v-icon dark>arrow_drop_down</v-icon>
              </v-toolbar-title>
            </template>

            <v-list two-line >
              <v-list-tile
                      v-for="(item,ind) in menu.sousMenus"
                      :key="ind"
                      router
                      :disabled="!item.etat"
                      :to="item.path"
                      v-if="item.etat">
                <v-list-tile-avatar >
                  <v-icon >{{ item.icon }}</v-icon>
                </v-list-tile-avatar>
                <v-list-tile-content >
                  <v-list-tile-title>{{ item.libelle }}</v-list-tile-title>
                </v-list-tile-content>
                <!--<v-list-tile-title v-text="item.libelle"></v-list-tile-title>-->
              </v-list-tile>
            </v-list>
          </v-menu>

        </template>

        <v-spacer></v-spacer>
        <v-menu bottom left  >
          <v-btn icon slot="activator">
            <v-avatar size="40px" class="grey lighten-4">
              <img v-if="user.url" :src="user.url" class="lazy" alt="">
              <img v-else src="http://archipro-v2.prodestic.net/webservice/web/uploads/avatars/default-avarta.png" class="lazy" alt="">
            </v-avatar>
          </v-btn>

          <v-list class="elevation-4">
            <v-list-tile @click.stop="dialogProfil = true">
              <v-list-tile-title>{{user.nom}}</v-list-tile-title>
            </v-list-tile>
            <v-list-tile  @click.stop="dialogMdp = true">
              <v-list-tile-title>Modifier votre mot de passe</v-list-tile-title>
            </v-list-tile>
            <v-list-tile v-if="droitAcces.index_parametre" router to='/parametre'>
              <v-list-tile-title>Paramètres</v-list-tile-title>
            </v-list-tile>
            <v-list-tile  @click.stop="dialogDeconnect = true">
              <v-list-tile-title>Se déconnecter</v-list-tile-title>
            </v-list-tile>
            <v-list-tile  >
              <v-list-tile-title  >
                Notifications
                <el-tooltip :content="'Notifications : ' + notif" placement="top">
                  <el-switch v-model="notif" @change="onChangeNotif" active-color="#ff4949" inactive-color="#13ce66" active-value="descactive" inactive-value="active">
                  </el-switch>
                </el-tooltip>
              </v-list-tile-title>
            </v-list-tile>
          </v-list>
        </v-menu>

      </v-toolbar>
    </v-card>

    <main>
      <v-content>
        <v-container fluid>
          <v-slide-x-transition mode="out-in">
            <router-view></router-view>
          </v-slide-x-transition>
        </v-container>
      </v-content>
    </main>

    <!-- MODAL DECONNEXION -->
    <v-dialog v-model="dialogDeconnect" max-width="40%">
      <v-card>
        <br>
        <h5 align="center">Voulez-vous vraiment vous déconnecter ?</h5>
        <p align="center">
          <v-btn flat color="blue darken-1" @click.stop="dialogDeconnect=false" large>Annuler</v-btn>
          <v-btn flat color="red" @click="deconnect" large>Confirmer</v-btn>
        </p>
        <v-card-actions></v-card-actions>
      </v-card>
    </v-dialog>

    <!-- MODAL PROFIL -->
    <v-dialog v-model="dialogProfil" max-width="80%" :overlay="true" scrollable persistent>
      <v-card>
        <v-toolbar style="flex: 0 0 auto;" dark class="blue">
          <v-toolbar-title>MON PROFIL {{user.nom}} </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click.native="dialogProfil = false" dark><v-icon>close</v-icon> </v-btn>
        </v-toolbar>

        <v-card-text>
          <el-row :gutter="20">
            <el-col :span="6">
              <div class="grid-content bg-purple">
                <el-card class="box-card" style="background:#fff">
                  <div>
                    <v-flex text-xs-center layout align-center justify-center>
                      <v-avatar size="140px" class="grey lighten-4">
                        <img v-if="user.url" :src="user.url" class="lazy" alt="">
                        <img v-else src="http://testerp.emacipro.com/webservice/web/uploads/avatars/default-avarta.png" class="lazy" alt="">
                      </v-avatar>
                    </v-flex>
                  </div>
                </el-card>
              </div>
            </el-col>

            <el-col :span="18" >
              <div class="grid-content" style="padding:3px">
                <el-row>
                  <el-col>
                    <div class="grid-content bg-purple">
                      <el-card class="box-card" style="background:#fff">
                        <v-layout row justify-left>
                          <v-flex md6>
                            <p><b>Nom et prénoms : </b> {{user.nom}}</p>
                            <p><b>Login :</b> {{user.email}} </p>
                            <p><b>Fonction :</b> {{user.fonction}} </p>
                            <p><b>Service :</b> {{user.service}} </p>
                          </v-flex>
                          <v-flex md6>
                            <p><b>Contact :</b> {{user.telephone}} </p>
                            <p><b>Date d'enrégistrement : </b> {{user.created}} </p>
                            <p><b>Date de modification :</b> {{user.modified}} </p>
                          </v-flex>
                        </v-layout>
                      </el-card>
                    </div>
                  </el-col>
                </el-row>
              </div>
              <br/>
            </el-col>
          </el-row>
          <v-tooltip top>
            <v-btn slot="activator" icons color="orange" @click.stop="dialogMdp = true" dark>Mot de passe <v-icon right>lock</v-icon></v-btn>
            Modifier votre mot de passe
          </v-tooltip>
          <v-tooltip top>
            <v-btn slot="activator" icons color="primary" @click.stop="editUser();" dark>Modifier <v-icon right>edit</v-icon></v-btn>
            Modifier votre profil
          </v-tooltip>
        </v-card-text>
        <div style="flex: 1 1 auto;"></div>
      </v-card>
    </v-dialog>

    <!-- MODAL MODIFIER MDP -->
    <v-dialog v-model="dialogMdp" max-width="70%" :overlay="true" scrollable persistent>
      <v-card>
        <v-toolbar style="flex: 0 0 auto;" dark class="blue">
          <v-toolbar-title>Modfifier votre mot de passe </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click.native="dialogMdp = false" dark><v-icon>close</v-icon> </v-btn>
        </v-toolbar>

        <v-card-text  element-loading-text="En cours d'enrégistrement ..." element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)">
          <v-form v-model="valid" ref="formMdp" lazy-validation id="formMdp">
            <v-container fluid grid-list-md>
              <v-layout row justify-left>
                <v-flex md4>
                  <v-text-field type="password" name="mdpUser" label="Votre ancien mot de passe" v-model="mdpUser" :rules="mdpUserRules" :counter="4" required></v-text-field>
                </v-flex>
                <v-flex md4>
                  <v-text-field type="password" name="mdpNewUser" label="Nouveau mot de passe" v-model="mdpNewUser" :rules="mdpNewUserRules" :counter="4" required></v-text-field>
                </v-flex>
                <v-flex md4>
                  <v-text-field type="password" name="mdpNewVerUser" label="Confirmer le nouveau mot de passe" v-model="mdpNewVerUser" :rules="mdpNewVerUserRules" :counter="4" required></v-text-field>
                </v-flex>
              </v-layout>
            </v-container>

            <v-btn @click="clear" color="orange" dark>Annuler <v-icon right>remove_circle</v-icon></v-btn>
            <v-btn icons color="blue" @click="submitMdp" :disabled="!valid" dark>Ajouter <v-icon right>add</v-icon></v-btn>
          </v-form>
        </v-card-text>
        <div style="flex: 1 1 auto;"></div>
      </v-card>
    </v-dialog>

    <!-- MODAL MODIFIER PROFIL -->
    <v-dialog v-model="dialogAjout" max-width="80%" :overlay="true" scrollable persistent>
      <v-card>
        <v-toolbar style="flex: 0 0 auto;" dark class="blue">
          <v-toolbar-title>
            <span>Modfifier votre profil {{user.nom}} </span>
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click.native="dialogAjout = false" dark><v-icon>close</v-icon> </v-btn>
        </v-toolbar>

        <v-card-text v-loading="loading" element-loading-text="En cours d'enrégistrement ..." element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)">
          <v-container fluid grid-list-md>
            <v-form v-model="valid" ref="formProfilUser" lazy-validation id="formProfilUser">
              <el-row :gutter="20">
                <el-col :span="6">
                  <div class="grid-content bg-purple">
                    <el-card class="box-card" style="background:#fff">
                      <div>
                        <v-flex text-xs-center layout align-center justify-center>
                          <el-upload class="upload-demo" list-type="picture-card" name="photo" action="" ref="upload" :auto-upload="false">
                            <img height="142" width="142" v-if="user.url" :src="user.url" class="lazy" alt="">
                            <img height="142" width="142" v-else src="http://webservice.prodestic.net/web/uploads/avatars/default-avarta.png" class="lazy" alt="">
                          </el-upload>
                        </v-flex>
                      </div>
                    </el-card>
                  </div>
                </el-col>
                <el-col :span="18" >
                  <div class="grid-content" style="padding:3px">
                    <el-row>
                      <el-col>
                        <div class="grid-content bg-purple">
                          <el-card class="box-card" style="background:#fff">
                            <v-layout row justify>
                              <v-flex md4>
                                <v-text-field label="Nom et prénoms" name="nomUser" v-model="nomUser" :rules="nomUserRules" :counter="4" required>
                                </v-text-field>
                              </v-flex>
                              <v-flex md4>
                                <v-text-field label="Login de connexion" name="loginUser" v-model="loginUser" :rules="loginUserRules" :counter="6" required>
                                </v-text-field>
                              </v-flex>
                              <v-flex md4>
                                <v-text-field label="Email" name="emailUser" v-model="emailUser" :rules="emailUserRules" :counter="6" required>
                                </v-text-field>
                              </v-flex>
                              <v-flex md4>
                                <v-text-field name="contactUser" label="Contact" v-model="contactUser" :counter="8" :rules="contactUserRules" hint="Exemple: 00-00-00-00" persistent-hint required></v-text-field>
                              </v-flex>
                            </v-layout>

                            <v-layout row justify>
                              <v-flex md4>
                                <v-text-field label="Fonction occupé" name="fonctionUser" v-model="fonctionUser" :counter="6" required></v-text-field>
                              </v-flex>
                              <v-flex md4>
                                <v-select label="Services" name="serviceUser" v-bind:items="listService" v-model="selectServiceUser" :rules="serviceUserRules" item-value="id" item-text="libelle" ></v-select>
                              </v-flex>

                              <v-flex md4>
                                <v-text-field type="password" name="mdpUserConnect" label="Votre mot de passe" v-model="mdpUserConnect" :rules="mdpUserConnectRules" :counter="4" required></v-text-field>
                              </v-flex>
                            </v-layout>
                          </el-card>
                        </div>
                      </el-col>
                    </el-row>
                  </div>
                  <br/>
                </el-col>
              </el-row>

              <v-btn @click="clear" color="orange" dark>Annuler <v-icon right>remove_circle</v-icon></v-btn>
              <v-btn icons color="blue" @click="submit" :disabled="!valid" dark>Ajouter <v-icon right>add</v-icon></v-btn>
            </v-form>
          </v-container>
        </v-card-text>
        <div style="flex: 1 1 auto;"></div>
      </v-card>
    </v-dialog>

  </v-app>

</template>
<script>
    import menuDrawer from '@/components/menu/Drawer';
    export default {
        name:"app",
        components:{menuDrawer},
        data () {
            return {
                notif: JSON.parse(sessionStorage.getItem('sessionNotif')),
                menus:[
                     {listeMenu: "Demande",etat:false,
                        sousMenus:[
                            {libelle:'Recueil de besoin' , icon:'payment' , route:'Besoin' , path:'/besoin', etat:true  },
                            {libelle:'Demande de fonds' , icon:'account_balance_wallet' , route:'DemandeFond' , path:'/demandeFond', etat:false  },
                          // {libelle:'Approbation des demandes de fonds' , icon:'account_balance_wallet' , route:'DemandeFondControle' , path:'/demandeFondControle', etat:true },
                            {libelle:'Liste des BCI' , icon:'account_balance_wallet' , route:'Besoin' , path:'/besoin/listeDeBci', etat:false  }
                        ]
                    },
                    {listeMenu: "Admin", etat:false,
                          sousMenus:[
                              {libelle:"Devis/factures & demandes d'absence" , icon:'list' , route:'ValidationDmd' , path:'/validationDmd', etat:false  },
                              {libelle:"Validation DEX" , icon:'list' , route:'ValidationDmd_dex' , path:'/validationDmd_dex', etat:false  },
                              {libelle:"Validation COST CONTROL" , icon:'list' , route:'ValidationDmd_post' , path:'/validationDmd_post', etat:false  },
                              {libelle:"Validation DGA/DOT" , icon:'list' , route:'ValidationDmd_dga' , path:'/validationDmd_dga', etat:false  },
                              {libelle:'Compte d\'exploitataion' , icon:'account_balance' , route:'BudgetChantier' , path:'/budgetChantier', etat:false },
                              {libelle:'Indicateur de productivité' , icon:'schedule' , route:'dashboardReporting' , path:'/reporting', etat: false },
                              {libelle:'Performance achat' , icon:'compare' , route:'comparateur' , path:'/comparateur', etat: false },
                              {libelle:'Indicateur projet' , icon:'home' , route:'indicateurProjet' , path:'/indicateur/projet', etat: false },
                          ]
                      },
                      {listeMenu: "Projet",  etat:false,
                          sousMenus:[
                              {libelle:'Projet' , icon:'home' , route:'Projet' , path:'/projet', etat:false  },
                              {libelle:'Worklogs' , icon:'work' , route:'Worklogs' , path:'/worklogs', etat:false  },
                              {libelle:'Board chantier' , icon:'business' , route:'DashBoardChantier' , path:'/boardChantier', etat:false  },
                              {libelle:'Board travaux' , icon:'business' , route:'DashboardTravaux' , path:'/boardTravaux', etat:false  },
                              {libelle:'Board Commis' , icon:'business' , route:'DashboardCommis' , path:'/boardCommis', etat:false  },
                              {libelle:'Performance rapport' , icon:'compare' , route:'comparateur_journal' , path:'/comparateur_journal', etat: false },
                              {libelle:'Tableau comparatif de projet' , icon:'home' , route:'DashboardComparatif' , path:'/boardComparatif/projet', etat:false  },
                              {libelle:'Tableau Analyse de rendement' , icon:'list' , route:'DashboardRapport' , path:'/boardRapport/projet', etat:false  },
                          ]
                      },
  
                      {listeMenu: "RH",  etat:false,
                          sousMenus:[
                              {libelle:'Board RH' , icon:'groups' , route:'indexResource' , path:'/indexResource', etat:false  },
                              {libelle:'Demande de conge' , icon:'check_box' , route:'boardEmploye' , path:'/boardEmploye', etat:true  },
                              {libelle:'Ressource technique' , icon:'group' , route:'listeOuvrier' , path:'/listeOuvrier', etat:false },
                              {libelle:'Mission' , icon:'drive_eta' , route:'Mission' , path:'/mission', etat:false  },
  
                          ]
                      },
  
                      {listeMenu: "Tiers",  etat:false,
                          sousMenus:[
                              {libelle:'Fournisseur et prestataire' , icon:'shopping_cart' , route:'Fournisseur' , path:'/fournisseur', etat:false  },
                              {libelle:'Magasin chantier' , icon:'store' , route:'Entrepot' , path:'/entrepot', etat:false  },
                              {libelle:'Client' , icon:'people' , route:'Client' , path:'/Client', etat:false  },
                              {libelle:"Recherche d'information" , icon:'search' , route:'search' , path:'/search', etat:true  },
                          ]
                      },
                      {listeMenu: "Logistique",  etat:false,
                          sousMenus:[
                              {libelle:'Tableau de bord' , icon:'ev_station' , route:'Parc' , path:'/parc/auto', etat:false  },
                          ]
                      },
                      {listeMenu: "Comptabilité",  etat:false,
                          sousMenus:[
                              {libelle:'Trésorerie' , icon:'account_balance_wallet' , route:'Caisse' , path:'/caisse', etat:false  },
                              {libelle:'Plan comptable' , icon:'list' , route:'PlanComptable' , path:'/plan-comptable', etat:true  }
                          ]
                      },
                      {listeMenu: "Paramètres",  etat:false,
                          sousMenus:[
                              {libelle:'Configuration' , icon:'settings' , route:'Parametre' , path:'/parametre', etat:false  },
                              {libelle:'Utilisateurs' , icon:'groups' , route:'User' , path:'/user', etat:false  },
                              {libelle:'Ressources & Type chantier' , icon:'store' , route:'Keywords' , path:'/keywords', etat:false  },
                          ]
                      },
                ],
                tabs: null,
                loading: false,
                domaine: JSON.parse(sessionStorage.getItem('sessionDomaine')),
                user: JSON.parse(sessionStorage.getItem('userInfo')),
                roleAcces: JSON.parse(sessionStorage.getItem('sessionAcces')),
                droitAcces: JSON.parse(sessionStorage.getItem('sessionDroit')),
                clipped: false,
                drawer: true,
                fixed: false,
                dialogDeconnect: false,
                dialogProfil: false,
                dialogMdp: false,
                dialogAjout: false,
                dialogImageUrl: '',
                dialogImageVisible: false,
                items: [
                    { icon: 'home', path: '/', title: 'Accueil' },
                    { icon: 'account_circle', path: '/user', title: 'Utilisateurs' },
                    { icon: 'assignment', path: '/fournisseur', title: 'Fournisseurs' }
                ],
                miniVariant: false,
                right: true,
                rightDrawer: false,
                title: 'ACHIPRO',
                valid: true,
                nomUser: '',
                loginUser: '',
                contactUser: '',
                fonctionUser: '',
                emailUser:"",
                listeMenus: [],
                listFinal: [],
                selectServiceUser: null,
                listService: [],
                serviceUserRules: [
                    (v) => !!v || 'Veuillez sélectionner votre service.',
                ],
                mdpUserConnect: '',
                mdpUser: '',
                mdpNewUser: '',
                mdpNewVerUser: '',
                mdpUserRules: [
                    (v) => !!v || 'Votre mot de passe est obligatoire',
                    (v) => v && v.length >= 4 || 'Vous devez renter pas moins de 4 caractères'
                ],
                mdpNewUserRules: [
                    (v) => !!v || 'Le nouveau mot de passe est obligatoire.',
                    (v) => v && v.length >= 4 || 'Vous devez renter pas moins de 4 caractères'
                ],
                mdpNewVerUserRules: [
                    (v) => !!v || 'Veuillez confirmer le nouveau mot de passe.',
                    (v) => v && v.length >= 4 || 'Vous devez renter pas moins de 4 caractères'
                ],
                mdpUserConnectRules: [
                    (v) => !!v || 'Votre mot de passe est obligatoire pour la confirmation'
                ],
                nomUserRules: [
                    (v) => !!v || 'Le nom est obligatoire',
                    (v) => v && v.length >= 4 || 'Vous devez renter pas moins de 4 caractères'
                ],
                loginUserRules: [
                    (v) => !!v || 'Le login est obligatoire',
                    (v) => v.length >= 4|| 'Vous devez renter pas moins de 4 caractères'
                ],
                emailUserRules: [
                    v => !!v || 'E-mail est obligatoire',
                    v => /.+@.+/.test(v) || 'Vous devez respecter format de E-mail'
                ],
                contactUserRules: [
                    (v) => !!v || "Le contact de l'utilisateur est obligatoire",
                    (v) => /[0-9]/.test(v) || 'Vous devez respecter format du contact'
                ],
                showdrawer: null,
                name: process.env.NAME,
                logo: process.env.LOGO


            }
        },
        mounted () {
            this.loadService()
            this.loadPage()
            this.menusVerif();
        },
        computed: {
            // un accesseur (getter) calculé
            menuShow: function ()
            {

                 let menusC =  this.menus.slice();
                const listeMenus =  menusC.filter( (menu) =>{
                    return menu.sousMenus.filter(sousM=>{
                      return sousM.etat == true
                    });
                });

                  let final = [];
                  for(let i=0;i<listeMenus.length;i++){
                     let comp = 0;
                    for(let j=0;j<listeMenus[i]['sousMenus'].length;j++){
                        if(listeMenus[i]['sousMenus'][j].etat == true)
                          {
                          comp++
                          }
                       }
                       if(comp !=0 ){
                          listeMenus[i].etat = true;
                          final.push(listeMenus[i])
                        }
                }
                return final;
            }
        },
        methods: {
            onChangeNotif () {
                this.notifs = this.notif
                let url = this.domaine+"userCreate/users/"+this.user.id;
                this.$http.get(url).then(resp =>{
                    sessionStorage.setItem("sessionNotif", JSON.stringify(this.notifs))
                    this.loading = false;
                    window.location.reload();
                 },error=>{
                    this.loading = false
                    this.$message.error("")
                });
            },
            menu (url) {
                this.$router.go({ name: url })
            },
            loadPage () {
                this.loading = true
            },
            loadService () {
                let url = this.domaine + 'webService/liste-service'
                this.$http.get(url).then(response => {
                    if (response.body) {
                        this.listService = response.body.service
                    }
                })
            },
            editUser () {
                this.dialogAjout = true
                this.nomUser = this.user.nom
                this.loginUser = this.user.username
                this.emailUser = this.user.email
                this.fonctionUser = this.user.fonction
                this.selectServiceUser = this.user.serviceId
                this.contactUser = this.user.telephone
                this.mdpUserConnect = ''
                this.loading = false
            },
            submit () {
                this.loading = true
                if (this.$refs.formProfilUser.validate()) {
                    if (this.mdpNewUser === this.mdpNewVerUser) {
                        var form = document.getElementById('formProfilUser')
                        var formdata = new FormData(form)
                        let url = this.domaine + 'userCreate/'+ this.user.id +'/user/edit'
                        formdata.append('idUser', this.user.id)
                        formdata.append('nomUser', this.nomUser)
                        formdata.append('loginUser', this.loginUser)
                        formdata.append('fonctionUser', this.fonctionUser)
                        formdata.append('emailUser', this.emailUser)
                        formdata.append('contactUser', this.contactUser)
                        formdata.append('serviceUser', this.selectServiceUser)
                        formdata.append('mdpUser', this.mdpUserConnect)

                        this.$http.post(url, formdata).then(response => {
                                if (response.body) {
                                    let verif = response.body
                                    if (verif.code === 1) {
                                        this.$notify({
                                            title: "L'UTILISATEUR A BIEN ETE MOFIFIE",
                                            message: 'Modification éffectué avec succès.',
                                            type: 'success',
                                            position: 'top-center'
                                        })
                                    } else if (verif.code === 2) {
                                        this.$message.error(verif.message)
                                    } else if (verif.code === 3) {
                                        this.$message.error(verif.message)
                                    } else if (verif.code === 4) {
                                        this.$message.error(verif.message)
                                    } else if (verif.code === 5) {
                                        this.$message.error(verif.message)
                                    }
                                    this.loading = false
                                    this.dialogAjout = false
                                    this.loadPage()
                                } else {
                                    this.$message.error('Erreur serveur')
                                    this.loading = false
                                    this.dialogAjout = false
                                }
                            },
                            response => {
                                this.$message.error('Erreur serveur')
                                this.loading = false
                            })
                    } else {
                        this.$message.error('Le mot de passe de vérification doit être identique a votre mot de passe')
                    }
                } else {
                    this.$message.error('Veuillez renseigner les champs obligatoires')
                    this.$notify.error({
                        title: "ERREUR D'ENREGISTREMENT",
                        message: "Utilisateur n'a pas été enregistré.",
                        position: 'top-center'
                    })
                    this.loading = false
                }
            },
            submitMdp () {
                this.loading = true
                if (this.$refs.formMdp.validate()) {
                    if (this.mdpNewUser === this.mdpNewVerUser) {
                        var form = document.getElementById('formMdp')
                        var formdata = new FormData(form)
                        let url = this.domaine +'userCreate/'+ this.user.id +'/edit/admin/password'
                        formdata.append('idUser', this.user.id)
                        this.$http.post(url, formdata).then(response => {
                                if (response.body) {
                                    let verif = response.body
                                    if (verif.code === 1) {
                                        this.$notify({
                                            title: "L'UTILISATEUR A BIEN ETE MOFIFIE",
                                            message: 'Modification éffectué avec succès.',
                                            type: 'success',
                                            position: 'top-center'
                                        })
                                    } else if (verif.code === 2) {
                                        this.$message.error(verif.message)
                                    } else if (verif.code === 3) {
                                        this.$message.error(verif.message)
                                    } else if (verif.code === 0) {
                                        this.$message.error(verif.message)
                                    }
                                    this.loading = false
                                    this.dialogMdp = false
                                    this.loadPage()
                                } else {
                                    this.$message.error('Erreur serveur')
                                    this.loading = false
                                }
                            },
                            response => {
                                this.$message.error('Erreur serveur')
                                this.loading = false
                            })
                    } else {
                        this.$message.error('Le mot de passe de vérification doit être identique au nouveau mot de passe')
                        this.loading = false
                    }
                } else {
                    this.$message.error('Veuillez renseigner les champs obligatoires')
                    this.$notify.error({
                        title: "ERREUR D'ENREGISTREMENT",
                        message: "Utilisateur n'a pas été enregistré.",
                        position: 'top-center'
                    })
                    this.loading = false
                }
            },
            submitNotif () {
                this.loading = true
                let url = this.domaine + 'userCreate/'+ this.user.id +'/notification/user'
                var data = new FormData()
                data.append('idUser', this.user.id)
                data.append('notif', this.notif)

                this.$http.post(url, data).then(response => {
                        if (response.body) {
                            let verif = response.body
                            let notification = response.body.data.notif
                            sessionStorage.setItem('sessionNotif', JSON.stringify(notification))

                            this.$notify({
                                title: "NOTIFICATION "+this.notif,
                                message: 'Modification éffectué avec succès.',
                                type: 'success',
                                position: 'top-center'
                            })

                            this.loading = false
                            this.loadPage()
                        } else {
                            this.$message.error('Erreur serveur')
                            this.loading = false
                        }
                    },
                    response => {
                        this.$message.error('Erreur serveur')
                        this.loading = false
                    })
            },
            clear () {
                this.$refs.formProfilUser.reset()
                this.dialogAjout = false
                this.dialogMdp = false
            },
            deconnect () {
                sessionStorage.clear()
                this.$router.go({ name: 'Login' })
            },
            menusVerif() {
                self = this;
                this.menus.forEach(function(menu)
                {
                    menu.sousMenus.forEach(sousM =>{
                        if(self.roleAcces[sousM.route]){
                            sousM.etat = true
                        }
                    })

                });
            }
        },
    };
</script>

<style>
.asterix {
  color: red
}
  @import '~fullcalendar/dist/fullcalendar.css';
  .application--light .tabs .tabs__item.tabs__item--active {
    color: #ffffff;
  }

  .application--light .tabs .tabs__item {
    color: #f1e8e8;
  }


</style>



// WEBPACK FOOTER //
// src/App.vue